import $ from '@modules/jquery-import';
import '@root/src/css/page-components/brandCarousel.scss';
import Swiper from 'swiper/bundle';

$( async () => {

    /*Dropdown Menu*/
    $( '.dropdown' ).click( function () {
        $( this ).attr( 'tabindex', 1 ).focus();
        $( this ).toggleClass( 'active' );
        $( this ).find( '.dropdown-menu' ).slideToggle( 300 );
        $( this ).find( '.dropdown-menu' ).css( {'display': 'flex'} );
    } );
    $( '.dropdown' ).focusout( function () {
        $( this ).removeClass( 'active' );
        $( this ).find( '.dropdown-menu' ).slideUp( 300 );
    } );
    $( '.dropdown .dropdown-menu li' ).click( function () {
        $( this ).parents( '.dropdown' ).find( 'span:first-child' ).text( $( this ).text() );
        $( this ).parents( '.dropdown' ).find( 'input' ).attr( 'value', $( this ).attr( 'id' ) );
    } );
    /*End Dropdown Menu*/

    $( () => {

        var swiper = new Swiper( '.my-swiperCarousel', {
            slidesPerView: 1,
            spaceBetween: 15,
            slidesPerGroup: 1,
            breakpoints: {
                1400: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                    slidesPerGroup: 4
                },
                752: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    slidesPerGroup: 3
                }
            },
            loop: true,
            loopFillGroupWithBlank: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        } );

    } )

} )
